import React, { Component } from "react";
import {
  Modal,
  Form,
  Input,
  TextArea,
  Header,
  Divider,
  Popup,
  Button,
} from "semantic-ui-react";
import "../SendHint/styles.css";
import { GiPresent } from "react-icons/gi";
import { sendHint } from "./services/apiSendHint";
import { errorMsgs } from "../../../../commons/functions/formValidations";
class ModalExampleDimmer extends Component {
  state = {
    open: false,
    name: { value: "", error: "" },
    recipient_name: { value: "", error: "" },
    message: { value: "", error: "" },
    email: { value: "", error: "" },
    imagen: "",
    url: "",
  };

  show = (dimmer) => () => this.setState({ dimmer, open: true });
  close = () => this.setState({ open: false });
  text(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  componentDidMount() {
    this.setState({
      imagen: this.props.detalleproducto,
      url: window.location.href,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.detalleproducto !== this.props.detalleproducto) {
      this.setState({ imagen: this.props.detalleproducto });
    }
  }
  send = () => {
    if (this.state.name.value === "") {
      this.setState({
        [this.state.name]: { value: "", error: errorMsgs.required },
      });
    } else if (this.state.recipient_name.value === "") {
      this.setState({
        [this.state.recipient_name]: { value: "", error: errorMsgs.required },
      });
    } else if (this.state.message.value === "") {
      this.setState({
        [this.state.message]: { value: "", error: errorMsgs.required },
      });
    } else if (this.state.email.value === "") {
      this.setState({
        [this.state.email]: { value: "", error: errorMsgs.required },
      });
    } else {
      const { name, recipient_name, email, message, imagen, url } = this.state;
      const data = {
        name: name.value,
        recipient_name: recipient_name.value,
        email: email.value,
        message: message.value,
        imagen,
        url,
      };
      sendHint(data);
      this.close();
    }
  };
  handleChange = (e, { name, value }) => {
    value === ""
      ? this.setState({ [name]: { value, error: errorMsgs.required } })
      : this.setState({ [name]: { value, error: "" } });
  };
  render() {
    const { open } = this.state;
    return (
      <>
        <button onClick={this.show("blurring")} className="btn-sendHint">
          <div className="container-hint">
            <div
              style={{
                display: "flex",
                flexGrow: 1,
                justifyContent: "center",
                alignItems: "flex-end",
                paddingBottom: 5,
              }}
            >
              <GiPresent size={20} />
            </div>
            <div
              style={{
                display: "flex",
                flexGrow: 1,
                justifyContent: "center",
                alignItems: "flex-end",
              }}
            >
              <span className="text-hint">Enviar una pista</span>
            </div>
            <div style={{ paddingLeft: 5 }}>
              <Popup
                content={`Envía una pista de lo que te gustaría regalase esa persona especial.`}
                trigger={
                  <Button circular icon="info" size="mini" color="grey" />
                }
              />
            </div>
          </div>
        </button>

        <Modal size="small" open={open} onClose={this.close} className="Cmodal">
          <div className="container-modal">
            <Header as="h2">
              <center>ENVÍA UNA PISTA</center>

              <center>
                <p className="subtitulo">
                  Hazle saber cuanto te encanta este arreglo
                </p>
              </center>
            </Header>

            <Divider clearing />
            <br></br>
            <Form>
              <Form.Group widths="equal">
                <Form.Input
                  id="form-input-control-first-name"
                  control={Input}
                  label="Su nombre"
                  placeholder=""
                  error={
                    this.state.name.error !== ""
                      ? {
                          content: this.state.name.error,
                          position: "above",
                        }
                      : false
                  }
                  name="name"
                  onChange={this.handleChange}
                  required
                />
                <Form.Field
                  id="form-input-control-last-name"
                  control={Input}
                  label="Nombre del destinatario"
                  placeholder=""
                  error={
                    this.state.recipient_name.error !== ""
                      ? {
                          content: this.state.recipient_name.error,
                          position: "above",
                        }
                      : false
                  }
                  name="recipient_name"
                  onChange={this.handleChange}
                  required
                />
                <Form.Field
                  id="form-input-control-last-name"
                  control={Input}
                  label="Correo del destinatario"
                  placeholder=""
                  name="email"
                  onChange={this.handleChange}
                  required
                  error={
                    this.state.email.error !== ""
                      ? {
                          content: this.state.email.error,
                          position: "above",
                        }
                      : false
                  }
                  type="email"
                />
              </Form.Group>
              <Form.Field
                id="form-textarea-control-opinion"
                control={TextArea}
                label="Mensaje"
                placeholder=""
                name="message"
                error={
                  this.state.message.error !== ""
                    ? {
                        content: this.state.message.error,
                        position: "above",
                      }
                    : false
                }
                onChange={this.handleChange}
                required
              />
              <div className="contenido">
                <center>
                  <div className="titulo-vistaprevia">
                    <h4 className="tituloHeaderVista">
                      VISTA PREVIA DE LA PISTA
                    </h4>
                  </div>
                  <div className="titulo-vistaprevia">
                    <h6 className="tituloHeader">
                      Hola, {this.state.recipient_name.value} .
                    </h6>
                  </div>

                  <div className="titulo-vistaprevia">
                    <h6 className="tituloHeader">
                      <b>{this.state.name.value}</b>, te ha enviado el siguiente
                      mensaje:
                    </h6>
                  </div>
                  <div>
                    <p className="tituloHeader">{this.state.message.value}</p>
                  </div>
                  <div
                    className="imagenPista"
                    style={{
                      backgroundImage: `url(${this.state.imagen})`,
                    }}
                  ></div>

                  <button className="buttonSend" onClick={() => this.send()}>
                    enviar pista
                  </button>
                </center>
              </div>
            </Form>
          </div>
        </Modal>
      </>
    );
  }
}

export default ModalExampleDimmer;
